var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJokerScratchTurboIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 2.625H14.4375C13.3932 2.625 12.3917 3.03984 11.6533 3.77827C10.9148 4.51669 10.5 5.51821 10.5 6.5625V35.4375C10.5 36.4818 10.9148 37.4833 11.6533 38.2217C12.3917 38.9602 13.3932 39.375 14.4375 39.375H27.5625C28.6068 39.375 29.6083 38.9602 30.3467 38.2217C31.0852 37.4833 31.5 36.4818 31.5 35.4375V6.5625C31.5 5.51821 31.0852 4.51669 30.3467 3.77827C29.6083 3.03984 28.6068 2.625 27.5625 2.625H23.625M18.375 2.625V5.25H23.625V2.625M18.375 2.625H23.625M18.375 35.4375H23.625",
    stroke: "url(#paint0_linear_6578_38244)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6578_38244",
    x1: 13.9799,
    y1: 17.1817,
    x2: 43.1985,
    y2: 30.3433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJokerScratchTurboIcon2);
export default __webpack_public_path__ + "static/media/jokerScratchTurboIcon2.736377fb43fb3eb6cc16f0bb24b07516.svg";
export { ForwardRef as ReactComponent };